import React from 'react'
import { Modal, Form, Select, DatePicker, Input, Button, theme } from 'antd'
import { PlusOutlined, CloseOutlined } from '@ant-design/icons'
import { hexToRGBA } from '../../../../lib/utils'

const { Option } = Select

const ActivityModal = ({ isVisible, onCancel, onAdd, form, filterValues }) => {
  const { token } = theme.useToken()
  const { activityTypes, departments, statuses } = filterValues || {
    activityTypes: [],
    departments: [],
    statuses: ['Scheduled', 'In Progress', 'Completed', 'Cancelled']
  }

  return (
    <Modal
      title='Log New Activity'
      visible={isVisible}
      onCancel={onCancel}
      footer={[
        <Button
          key='cancel'
          onClick={onCancel}
          icon={<CloseOutlined style={{ color: token.colorError }} />}
          style={{
            background: hexToRGBA(token.colorError, 0.1),
            borderColor: token.colorError,
            color: token.colorError
          }}
        >
          Cancel
        </Button>,
        <Button
          key='submit'
          onClick={onAdd}
          icon={<PlusOutlined style={{ color: token.colorSuccess }} />}
          style={{
            background: hexToRGBA(token.colorSuccess, 0.1),
            borderColor: token.colorSuccess,
            color: token.colorSuccess,
            fontWeight: 'bold'
          }}
        >
          Log Activity
        </Button>
      ]}
      width={700}
    >
      <Form form={form} layout='vertical'>
        <Form.Item
          name='caregiverId'
          label='Caregiver'
          rules={[{ required: true, message: 'Please select a caregiver' }]}
        >
          <Select placeholder='Select caregiver'>
            <Option value='STAFF-123'>Nurse Sarah Collins (STAFF-123)</Option>
            <Option value='STAFF-145'>Nurse Michael Chen (STAFF-145)</Option>
            <Option value='STAFF-167'>Nurse Amanda Rodriguez (STAFF-167)</Option>
            {/* More options would be populated from staff database */}
          </Select>
        </Form.Item>

        <Form.Item name='patientId' label='Patient' rules={[{ required: true, message: 'Please select a patient' }]}>
          <Select placeholder='Select patient'>
            <Option value='PT-1001'>John Smith (PT-1001)</Option>
            <Option value='PT-1023'>Emma Wilson (PT-1023)</Option>
            <Option value='PT-1045'>Michael Brown (PT-1045)</Option>
            {/* More options would be populated from patients database */}
          </Select>
        </Form.Item>

        <Form.Item
          name='activityType'
          label='Activity Type'
          rules={[{ required: true, message: 'Please select activity type' }]}
        >
          <Select placeholder='Select activity type'>
            {activityTypes.map((type) => (
              <Option key={type} value={type}>
                {type}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name='startTime'
          label='Start Time'
          rules={[{ required: true, message: 'Please specify start time' }]}
        >
          <DatePicker showTime format='YYYY-MM-DD HH:mm' style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item name='endTime' label='End Time'>
          <DatePicker showTime format='YYYY-MM-DD HH:mm' style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          name='department'
          label='Department'
          rules={[{ required: true, message: 'Please select department' }]}
        >
          <Select placeholder='Select department'>
            {departments.map((dept) => (
              <Option key={dept} value={dept}>
                {dept}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name='roomNumber'
          label='Room Number'
          rules={[{ required: true, message: 'Please enter room number' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item name='notes' label='Activity Notes'>
          <Input.TextArea rows={3} />
        </Form.Item>

        <Form.Item name='caregiverFeedback' label='Caregiver Feedback'>
          <Input.TextArea rows={2} />
        </Form.Item>

        <Form.Item name='status' label='Status' rules={[{ required: true, message: 'Please select status' }]}>
          <Select placeholder='Select status'>
            {statuses.map((status) => (
              <Option key={status} value={status}>
                {status}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ActivityModal
